import { ColumnsType } from 'antd/es/table'
import { Tooltip } from '../../../../../components/Tooltip/Tooltip'
import { TOOLTIP } from '../../../../../constants'
import { ReactComponent as InfoIcon } from 'assets/svg/Information.svg'
import { LedByCommunityGroup } from './types'

export const columns: ColumnsType<LedByCommunityGroup> = [
  {
    dataIndex: 'hs',
    key: 'hs',
    title: 'HS',
    width: '40%',
    render: (_, { rows }) => (
      <div className="flex column gap-16">
        {rows?.map(({ hs, uuid }) => (
          <div key={uuid} className="separate-item">
            {hs}
          </div>
        ))}
      </div>
    )
  },
  {
    dataIndex: 'gpo_allocation',
    key: 'gpo_allocation',
    align: 'right',
    className: 'align-center',
    title: (
      <Tooltip title={TOOLTIP.GPO_ALLOCATION}>
        <div className="row align-center gap-8">
          <InfoIcon className="info-icon" /> GPO allocation,%
        </div>
      </Tooltip>
    ),
    render: (_, { gpo_allocation }) =>
      gpo_allocation ? `${gpo_allocation}%` : '---'
  },
  {
    dataIndex: 'remaining',
    key: 'remaining',
    title: 'Remaining to be distributed',
    align: 'right',
    className: 'grey-row align-center',
    render: (_, { remaining }) => (remaining ? `${remaining}%` : '---')
  },
  {
    dataIndex: 'co_retain',
    key: 'co_retain',
    align: 'right',
    title: (
      <Tooltip title={TOOLTIP.CO_SPLIT}>
        <div className="row align-center gap-8">
          <InfoIcon className="info-icon" /> CO retain,%
        </div>
      </Tooltip>
    ),
    render: (_, { rows }) => (
      <div className="flex column gap-16">
        {rows?.map(({ co_retain, uuid }) => (
          <div key={uuid} className="separate-item">
            {co_retain ? `${co_retain}%` : '---'}
          </div>
        ))}
      </div>
    )
  },
  {
    dataIndex: 'hs_split',
    key: 'hs_split',
    align: 'right',
    title: (
      <Tooltip title={TOOLTIP.HS_SPLIT}>
        <div className="row align-center gap-8">
          <InfoIcon className="info-icon" /> HS split,%
        </div>
      </Tooltip>
    ),
    render: (_, { rows }) => (
      <div className="flex column gap-16">
        {rows?.map(({ hs_split, uuid }) => (
          <div key={uuid} className="separate-item">
            {hs_split ? `${hs_split}%` : '---'}
          </div>
        ))}
      </div>
    )
  }
]

export const HS_SIBLING_FIELD_ERROR_MESSAGE = {
  co_retain: 'HS split is required',
  hs_split: 'CO retain is required'
} as const
